module.exports = __webpack_public_path__ + "fonts/poppins-light-webfont.6d789b05.woff2";